import React, { useState } from 'react';
import { SwitchStyles } from './styles';
import { ISwitchCommon } from './types';

export const SwitchCommon: React.FC<ISwitchCommon> = ({ defaultChecked = false, onChange, checked, disabled }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
    if (onChange) onChange(event);
  };

  return <SwitchStyles disabled={disabled} checked={checked ?? isChecked} onChange={handleSwitchChange} />;
};
